// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item {
  transition: all 0.5s ease-in-out !important;
}

/* .item:hover {
  --bs-bg-rgb-color: var(--bs-light-rgb);
  background-color: rgba(var(--bs-bg-rgb-color), 0.50) !important;
} */

.more-info {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transform: translateY(-10px);
  transition: all 0.5s ease-in-out !important;
}
.item:hover .more-info {
  opacity: 1;
  transform: translateY(0px);
  max-height: 50px;
}

.item:hover .opacity-100-on-item-hover {
  opacity: 1 !important;
}



.item:not(.selected) {
  opacity: 0.8;
}

.item:not(.selected):hover {
  opacity: 1;
}


.item.selected {
  opacity: 1;
  --bs-bg-rgb-color: var(--bs-light-rgb);
  background-color: rgba(var(--bs-bg-rgb-color), 0.50) !important;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm9mZmVyLWxpc3QtbWluaW1hbC1pdGVtLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSwyQ0FBMkM7QUFDN0M7O0FBRUE7OztHQUdHOztBQUVIO0VBQ0UsYUFBYTtFQUNiLGdCQUFnQjtFQUNoQixVQUFVO0VBQ1YsNEJBQTRCO0VBQzVCLDJDQUEyQztBQUM3QztBQUNBO0VBQ0UsVUFBVTtFQUNWLDBCQUEwQjtFQUMxQixnQkFBZ0I7QUFDbEI7O0FBRUE7RUFDRSxxQkFBcUI7QUFDdkI7Ozs7QUFJQTtFQUNFLFlBQVk7QUFDZDs7QUFFQTtFQUNFLFVBQVU7QUFDWjs7O0FBR0E7RUFDRSxVQUFVO0VBQ1Ysc0NBQXNDO0VBQ3RDLCtEQUErRDtBQUNqRSIsImZpbGUiOiJvZmZlci1saXN0LW1pbmltYWwtaXRlbS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLml0ZW0ge1xuICB0cmFuc2l0aW9uOiBhbGwgMC41cyBlYXNlLWluLW91dCAhaW1wb3J0YW50O1xufVxuXG4vKiAuaXRlbTpob3ZlciB7XG4gIC0tYnMtYmctcmdiLWNvbG9yOiB2YXIoLS1icy1saWdodC1yZ2IpO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiByZ2JhKHZhcigtLWJzLWJnLXJnYi1jb2xvciksIDAuNTApICFpbXBvcnRhbnQ7XG59ICovXG5cbi5tb3JlLWluZm8ge1xuICBtYXgtaGVpZ2h0OiAwO1xuICBvdmVyZmxvdzogaGlkZGVuO1xuICBvcGFjaXR5OiAwO1xuICB0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoLTEwcHgpO1xuICB0cmFuc2l0aW9uOiBhbGwgMC41cyBlYXNlLWluLW91dCAhaW1wb3J0YW50O1xufVxuLml0ZW06aG92ZXIgLm1vcmUtaW5mbyB7XG4gIG9wYWNpdHk6IDE7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgwcHgpO1xuICBtYXgtaGVpZ2h0OiA1MHB4O1xufVxuXG4uaXRlbTpob3ZlciAub3BhY2l0eS0xMDAtb24taXRlbS1ob3ZlciB7XG4gIG9wYWNpdHk6IDEgIWltcG9ydGFudDtcbn1cblxuXG5cbi5pdGVtOm5vdCguc2VsZWN0ZWQpIHtcbiAgb3BhY2l0eTogMC44O1xufVxuXG4uaXRlbTpub3QoLnNlbGVjdGVkKTpob3ZlciB7XG4gIG9wYWNpdHk6IDE7XG59XG5cblxuLml0ZW0uc2VsZWN0ZWQge1xuICBvcGFjaXR5OiAxO1xuICAtLWJzLWJnLXJnYi1jb2xvcjogdmFyKC0tYnMtbGlnaHQtcmdiKTtcbiAgYmFja2dyb3VuZC1jb2xvcjogcmdiYSh2YXIoLS1icy1iZy1yZ2ItY29sb3IpLCAwLjUwKSAhaW1wb3J0YW50O1xufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/shared/partials/main-lists/offers-list/offer-list-minimal-item/offer-list-minimal-item.component.css"],"names":[],"mappings":"AAAA;EACE,2CAA2C;AAC7C;;AAEA;;;GAGG;;AAEH;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,4BAA4B;EAC5B,2CAA2C;AAC7C;AACA;EACE,UAAU;EACV,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;;;AAIA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,UAAU;EACV,sCAAsC;EACtC,+DAA+D;AACjE;AACA,gnDAAgnD","sourcesContent":[".item {\n  transition: all 0.5s ease-in-out !important;\n}\n\n/* .item:hover {\n  --bs-bg-rgb-color: var(--bs-light-rgb);\n  background-color: rgba(var(--bs-bg-rgb-color), 0.50) !important;\n} */\n\n.more-info {\n  max-height: 0;\n  overflow: hidden;\n  opacity: 0;\n  transform: translateY(-10px);\n  transition: all 0.5s ease-in-out !important;\n}\n.item:hover .more-info {\n  opacity: 1;\n  transform: translateY(0px);\n  max-height: 50px;\n}\n\n.item:hover .opacity-100-on-item-hover {\n  opacity: 1 !important;\n}\n\n\n\n.item:not(.selected) {\n  opacity: 0.8;\n}\n\n.item:not(.selected):hover {\n  opacity: 1;\n}\n\n\n.item.selected {\n  opacity: 1;\n  --bs-bg-rgb-color: var(--bs-light-rgb);\n  background-color: rgba(var(--bs-bg-rgb-color), 0.50) !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
